import React from "react";

import "./webView.css";
import { WEB_URL } from "../utilities/urls";


const url = WEB_URL

const WebView = () => {
  return (
    <div className="webView">
      <div className="webView-wrapper">
        <div className="webView-iframe-wrapper">
          <iframe src={url}>
          </iframe>
            
        </div>
      </div>
    </div>
  );
};

export default WebView;
